<script>
    import BgSelectReferenceModal from "@/components/BgSelectReferenceModal.vue";

    export default {
        components: {
            BgSelectReferenceModal
        },

        props: {
            currentId: {
                required: true,
                type: String,
            },
            filter: {
                type: Object,
                default() {
                    return {}
                },
            },
            label: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                relationTab: 'group',
                selectRelation: false,
                relationObject: 'Group',
                relationLabel: this.$t("Sub-brand"),
            }
        },

        methods: {
            reloadContents() {
                this.$root.findChild(this, 'BgTable', table => {
                    table.itemsLoading = true
                    table.fetch()
                })
            },

            removeRelation(connectionId) {
                if (confirm(this.$t('Do you want to remove this relation?'))) {
                    const params = {
                        'filter[ReferenceId]': this.currentId,
                        'filter[GroupId]': connectionId,
                    }
                    this.$root.delete('reference-2-' + this.relationTab, params).then(() => {
                        this.reloadContents()
                    })
                }
            },
        },
    }
</script>

<template>
    <div>
        <div style="margin: 0 0 1.25rem">
            <div class="level">
                <div class="level-left"></div>
                <div class="level-right">
                    <button @click.prevent="selectRelation = true" class="button is-primary">
                        {{ $t('New %CollectionName% relation') | sprintf({'%CollectionName%': relationLabel}) }}
                    </button>
                </div>
            </div>
        </div>

        <bg-table :label="label" :path="relationTab" :object="relationObject" :filter="filter" :site-columns="false">
            <template v-slot="data">
                <bg-column :label="$t('Item number')" sort="SapId">{{ data.row.SapId }}</bg-column>
                <bg-column :label="$t('Name')" sort="Name">{{ data.row.GroupI18ns[0].Name }}</bg-column>
            </template>

            <template v-slot:tools="data">
                <button @click.prevent="removeRelation(data.row.Id)"
                        :title="$t('Remove relation')"
                        class="button is-danger"
                        type="button"
                        style="border-radius: 50%">
                    <b-icon icon="link-variant-off" custom-size="default"/>
                </button>
            </template>
        </bg-table>

        <bg-select-reference-modal @close="selectRelation = false"
                                   :show="selectRelation"
                                   :referenceId="parseInt(filter.ReferenceId)"
                                   :relationObject="relationObject"
                                   :relationLabel="relationLabel"
                                   :relationTab="relationTab"/>
    </div>
</template>
